import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../api/axios.js";

const AssignPosition = () => {
    const [lessons, setLessons] = useState([]);
    const [fileNames, setFileNames] = useState([])
    const [positions, setPositions] = useState([]);
    const [selectedPositions, setSelectedPositions] = useState(new Set());
    const [selected, setSelected] = useState(new Set());
    const [assigning, setAssigning] = useState(false);
    const [message, setMessage] = useState("");

    const location = useLocation();

    useEffect(() => {
        api.get('/api/positions')
            .then(r => setPositions(r.data || []))
            .catch(e => console.error('positions fetch', e));
    }, []);

    useEffect(() => {
        const sel = location?.state?.selected;
        const names = location?.state?.fileNames;
        if (Array.isArray(sel) && sel.length > 0) {
            setSelected(new Set(sel));
        }
        if (Array.isArray(names) && names.length > 0) {
            setFileNames(names);
        }
    }, [location]);

    const assignSelected = async () => {
        if (selected.size === 0) return;
        setAssigning(true);
        try {
            await api.post('/api/lessons/assign', { lessonIds: Array.from(selected), positions: Array.from(selectedPositions) });
            const positionList = Array.from(selectedPositions).join(", ") || "selected"; 
            const displayNames = (Array.isArray(fileNames) && fileNames.length > 0)
                ? fileNames.join(", ")
                : `${Array.from(selected).length} file(s)`;
            setMessage(`${displayNames} has been assigned to ${positionList} position`);
            setTimeout(() => setMessage(""), 5000);
            setSelected(new Set());
            setSelectedPositions(new Set());
        } catch (err) {
            console.error(err);
        } finally {
            setAssigning(false);
        }
    };

    return (
        <>
            {message && <p className="success-message">{message}</p>}
            <div className="assign-title">
                <p>Select positions</p>
                <p>Please select the position(s) to assign or delete.</p>
            </div>
            <div className="assign-positions">

                {positions.length === 0 && <p>No positions found</p>}
                {positions.length > 0 && (
                    <div className="position-wrapper">
                        {/* {positions.map(p => (
                                        <label key={p} style={{ marginRight: 12 }}>
                                            <input
                                                style={{ accentColor: "black" }}
                                                type="checkbox"
                                                checked={selectedPositions.has(p)}
                                                onChange={() => setSelectedPositions(prev => {
                                                    const next = new Set(prev);
                                                    if (next.has(p)) next.delete(p); else next.add(p);
                                                    return next;
                                                })}
                                            /> {p}
                                        </label>
                                    ))} */}
                        <ul>
                            <li>
                                <label>
                                    <input
                                        style={{ accentColor: "black" }}
                                        type="checkbox"
                                        checked={selectedPositions.has("Baker")}
                                        onChange={() => setSelectedPositions(prev => {
                                            const next = new Set(prev);
                                            if (next.has("Baker")) next.delete("Baker"); else next.add("Baker");
                                            return next;
                                        })}
                                    />
                                    Baker
                                </label>
                                <img src="/images/baker.png" />
                            </li>
                            <li>
                                <label>
                                    <input
                                        style={{ accentColor: "black" }}
                                        type="checkbox"
                                        checked={selectedPositions.has("Server")}
                                        onChange={() => setSelectedPositions(prev => {
                                            const next = new Set(prev);
                                            if (next.has("Server")) next.delete("Server"); else next.add("Server");
                                            return next;
                                        })}
                                    />
                                    Server
                                </label>
                                <img src="/images/server.png" />
                            </li>
                            <li>
                                <label>
                                    <input
                                        style={{ accentColor: "black" }}
                                        type="checkbox"
                                        checked={selectedPositions.has("Barista")}
                                        onChange={() => setSelectedPositions(prev => {
                                            const next = new Set(prev);
                                            if (next.has("Barista")) next.delete("Barista"); else next.add("Barista");
                                            return next;
                                        })}
                                    />
                                    Barista
                                </label>
                                <img src="/images/barista.png" />
                            </li>
                        </ul>
                        <div className="flex-button">
                            <button
                                onClick={assignSelected}
                                disabled={assigning || selected.size === 0}
                                className="cancel"
                            >
                                Delete
                            </button>
                            <button
                                onClick={assignSelected}
                                disabled={assigning || selected.size === 0}
                            >
                                Assign
                            </button>
                        </div>
                    </div>
                )}

            </div>

        </>
    )
}

export default AssignPosition;